import { appendCountryCodeAndFormatMobile } from '@helpers/miscelleanous';
import { Image, Text } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import React from 'react';
import texts from './en.json';
import { supportEmail, supportPhoneNumber } from '@helpers/constants';
import { copyText } from '@ui/molecules/OpportunityHtmlOptions/helpers';

export const DesktopRmConsultationBanner = ({
    rmDetails,
    showRMDetails,
    whatsappLink,
}) => {
    return showRMDetails ? (
        <div
            className={`flex flex-col xl:flex-row px-4 py-3 gap-4 mb-10 bg-opportunity-help-banner-bg rounded-xl border-gray-200 border-1`}
        >
            <div className={`flex flex-col gap-2 xl:max-w-[200px]`}>
                <Text
                    content={texts.NeedHelpFindingRightOpportunity}
                    className="h7-semibold text-primary-500 "
                />
                <Text
                    content={texts.ConsultWithYourRm}
                    className="p5-regular text-gray-600 "
                />
            </div>
            <div className="flex flex-col xl:flex-row p-3 bg-opportunity-help-banner-inner-bg rounded-l-xl gap-4 flex-1 xl:items-center">
                <RmProfileComponent rmDetails={rmDetails} />
                <RmCtaComponent
                    rmDetails={rmDetails}
                    showRMDetails={showRMDetails}
                    whatsappLink={whatsappLink}
                />
            </div>
        </div>
    ) : null;
};

export const RmProfileComponent = ({ rmDetails }) => {
    return (
        <div className="flex flex-1 gap-4 items-center ">
            <Image
                src={`${
                    rmDetails?.profileImageLink
                        ? rmDetails.profileImageLink
                        : '/images/user-solid.svg'
                }`}
                className={`w-14 h-14  ${
                    !rmDetails?.profileImageLink
                        ? 'border-2 border-gray-400 bg-gray-400'
                        : 'border-4 border-secondary-300'
                } rounded-full`}
            />
            <div className="flex flex-col gap-[2px]">
                <Text
                    className="h6-semibold text-gray-900"
                    content={rmDetails?.name || '-'}
                />
                <Text
                    className="p5-regular text-gray-500"
                    content={texts.AvailableTimings}
                />
            </div>
        </div>
    );
};

export const RmCtaComponent = ({ rmDetails, showRMDetails, whatsappLink }) => {
    return (
        <div className="flex flex-wrap items-center h-10 gap-4">
            <Button
                buttonType="secondary"
                buttonSize="small"
                prefixComponent={<Image src="/images/phone.svg" alt="mobile" />}
                iconSize="h-4 w-4"
                buttonText={
                    showRMDetails && rmDetails?.mobile ? appendCountryCodeAndFormatMobile(rmDetails.mobile, "+91") : '-'
                }
                className="text-primary-500 p4-medium"
                onClick={() =>
                    copyText(
                        showRMDetails && rmDetails?.mobile
                            ? appendCountryCodeAndFormatMobile(rmDetails.mobile, "+91")
                            : '-',
                        'mobile'
                    )
                }
            />
            <a href={whatsappLink} target="_blank">
                <Button
                    buttonType="secondary"
                    buttonSize="small"
                    prefixComponent={
                        <Image src="/images/whatsapp-icon.svg" alt="whatsapp" />
                    }
                    iconSize="h-4 w-4"
                    className="text-primary-500 p4-medium"
                    buttonText={'WhatsApp'}
                />
            </a>
            {showRMDetails && rmDetails?.calendlyLink ? (
                <a href={rmDetails?.calendlyLink} target="_blank">
                    <Button
                        buttonType="secondary"
                        buttonSize="small"
                        prefixComponent={
                            <Image
                                src="/images/CalendarCheck.svg"
                                alt="calendarCheck"
                            />
                        }
                        iconSize="h-4 w-4"
                        className="text-primary-500 p4-medium"
                        buttonText={texts.BookConsultation}
                    />
                </a>
            ) : null}
        </div>
    );
};

export const NoRmCtaComponent = () => {
    return (
        <div className="flex flex-wrap w-full gap-3">
            <Button
                buttonType="textunderline"
                buttonSize="small"
                prefixComponent={
                    <Image src="/images/phone-gradient.svg" alt="mobile" />
                }
                iconSize="h-6 w-6"
                buttonText={supportPhoneNumber}
                className="text-primary-500 p4-medium bg-basicWhite/80 rounded-xl h-12 p-3 !w-max !text-start !justify-start"
                onClick={() => copyText(supportPhoneNumber, 'mobile')}
            />
            <a
                href={`mailto:${supportEmail}`}
                target="_blank"
                className="w-auto"
            >
                <Button
                    buttonType="textunderline"
                    buttonSize="small"
                    prefixComponent={
                        <Image
                            src="/images/message-gradient.svg"
                            alt="mobile"
                        />
                    }
                    iconSize="h-6 w-6"
                    buttonText={supportEmail}
                    className="text-primary-500 p4-medium  bg-basicWhite/80 rounded-xl h-12 p-3 !w-max !text-start !justify-start"
                />
            </a>
        </div>
    );
};
